const Reviewer = [
  {
    url: "/",
    text: "Home",
  },
  {
    url: "/find-companies",
    text: "Find Companies",
  },
  {
    url: "/find-projects",
    text: "Find Projects",
  },
  {
    url: "#",
    text: "Blog",
  },
];

const Company = [
  {
    url: "/about-us",
    text: "Why Get Listed",
  },
  {
    url: "/user/signin",
    text: "Company Signin",
  },
  {
    url: "/user/signup",
    text: "Company Signup",
  },
  {
    url: "/contact-us",
    text: "Help Center",
  },
];

const About = [
  {
    url: "/about-us",
    text: "About Us",
  },
  {
    url: "/privacy-policy",
    text: "Privacy Policy",
  },
  {
    url: "/faqs",
    text: "FAQs",
  },
  {
    url: "/contact-us",
    text: "Contact Us",
  },
];

export { Reviewer, Company, About };
